module.exports = __webpack_public_path__ + "static/img/img4_en.91222788.png";